import type { IElement, IMessageElement } from '@chainlit/react-client';

import type { Artifact } from '@/components/ScheduledAgents/ArtifactShelf';

export const isMcpAppElement = (el: IElement) =>
    el.type === 'custom' && el.name === 'mcpApp';

export const isHtmlPreviewElement = (el: IElement) =>
    el.type === 'custom' && el.name === 'HtmlPreview';

export const isInlineRunElement = (el: IElement): el is IMessageElement =>
    el.type !== 'tasklist' && !isMcpAppElement(el) && !isHtmlPreviewElement(el);

export function htmlArtifactsOf(elements: IElement[]): Artifact[] {
    return elements.filter(isHtmlPreviewElement).map((el) => ({
        id: el.id,
        filename: (el as any).props?.filename ?? 'output.html',
        html: (el as any).props?.html ?? ''
    }));
}
